import React from 'react';
import Modal from './Modal';
import { AlertCircle, AlertTriangle, Info, CheckCircle2 } from 'lucide-react';

export const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Confirm action",
  message = "Are you sure you want to proceed?",
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  //update Halimunnisa 09-06-2026
  //confirmation modals can be of different types - warning, danger, info, success - which will affect the icon and colors used. The 'type' prop is deprecated in favor of 'variant' for better semantics, but both are supported for now.
  type,
  variant,
  isLoading = false
}) => {
  const finalType = variant || type || 'warning';

  const icons = {
    warning: <AlertTriangle className="w-12 h-12 text-slate-800 bg-slate-100 p-2.5 rounded-2xl" />,
    danger: <AlertCircle className="w-12 h-12 text-rose-600 bg-rose-50 p-2.5 rounded-2xl" />,
    info: <Info className="w-12 h-12 text-slate-800 bg-slate-100 p-2.5 rounded-2xl" />,
    success: <CheckCircle2 className="w-12 h-12 text-emerald-600 bg-emerald-50 p-2.5 rounded-2xl" />,
  };

  const confirmColors = {
    warning: 'bg-slate-800 hover:bg-slate-900',
    danger: 'bg-slate-800 hover:bg-slate-900',
    info: 'bg-slate-800 hover:bg-slate-900',
    success: 'bg-emerald-600 hover:bg-emerald-700',
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size="sm"
      footer={
        <div className="flex items-center gap-3 w-full">
          <button
            type="button"
            onClick={onClose}
            disabled={isLoading}
            className="flex-1 h-11 bg-white border border-slate-200 text-slate-600 rounded-xl text-sm font-bold hover:bg-slate-50 transition-colors disabled:opacity-50"
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={isLoading}
            className={`flex-1 h-11 ${confirmColors[finalType] || confirmColors.warning} text-white rounded-xl text-sm font-bold shadow-sm transition-all active:scale-95 disabled:opacity-50 flex items-center justify-center gap-2`}
          >
            {isLoading && (
              <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
            )}
            {confirmLabel}
          </button>
        </div>
      }
    >
      <div className="flex flex-col items-center text-center gap-4 py-2">
        {icons[finalType] || icons.warning}
        <div className="flex flex-col gap-1">
          <h3 className="text-lg font-bold text-slate-800">{title}</h3>
          <p className="text-sm text-slate-500 leading-relaxed max-w-[280px] mx-auto">
            {message}
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
